import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentTypeChecking: {
        id: 'tfpa.endorsement.directives.templates.bank-account-details.Checking',
        defaultMessage: 'Checking',
    },
    paymentTypeSavings: {
        id: 'tfpa.endorsement.directives.templates.bank-account-details.Savings',
        defaultMessage: 'Savings',
    },
    paymentOptions: {
        id: 'tfpa.quoteandbind.views.payment-details.Payment Options',
        defaultMessage: 'Payment Options',
    },
    averageMonthlyPremium: {
        id: 'tfpa.quoteandbind.views.payment-details.Average Monthly Premium',
        defaultMessage: 'Average Monthly Premium:',
    },
    paymentDetails: {
        id: 'tfpa.quoteandbind.views.payment-details.Payment Details',
        defaultMessage: 'Payment Details',
    },
    totalPremium: {
        id: 'tfpa.quoteandbind.views.payment-details.Total Premium:',
        defaultMessage: 'Total Premium:',
    },
    paymentBuyNow: {
        id: 'tfpa.quoteandbind.views.payment-details.Submit',
        defaultMessage: 'Submit',
    },
    paymentPlanAlertTitle:{
        id: 'tfpa.quoteandbind.views.payment-details.Please choose a payment plan',
        defaultMessage: 'Please choose a payment plan',
    },
    paymentPlanAlertMessage:{
        id: 'tfpa.quoteandbind.views.payment-details.You have not chosen a payment plan. Please select a payment plan and try again.',
        defaultMessage: 'You have not chosen a payment plan. Please select a payment plan and try again.',
    },
    uwIssueTitle:{
        id: 'tfpa.quoteandbind.views.payment-details.Underwriting issues have been triggered.',
        defaultMessage: 'Underwriting issues have been triggered',
    },
    uwIssueMessage:{
        id: 'tfpa.quoteandbind.views.payment-details.Redirecting to underwriting issues for this quote.',
        defaultMessage: 'Redirecting to underwriting issues for this quote.',
    },
    uwActionLabel:{
        id: 'tfpa.quoteandbind.views.payment-details.View Issues',
        defaultMessage: 'View Issues',
    },
    confirmTransaction: {
        id: "tfpa.quoteandbind.views.confirmTransaction",
        defaultMessage: "Confirm Transaction",
    },
    confirmTransactionMsg: {
        id: "tfpa.quoteandbind.views.confirmTransactionMsg",
        defaultMessage: "This transaction cannot be modified after it has been submitted. Do you want to continue?",
    },
});
